import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { ShieldAlert } from "lucide-react";

const STORAGE_KEY = "hitpath_age_ack_v1";

export const AgeGate = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setOpen(true);
    } catch {
      setOpen(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {
      /* ignore */
    }
    setOpen(false);
  };

  const decline = () => {
    window.location.href = "https://www.google.com";
  };

  if (!open) return null;

  return (
    <div
      data-testid="age-gate-overlay"
      className="fixed inset-0 z-50 bg-black/85 backdrop-blur-sm flex items-center justify-center p-4"
    >
      <div className="w-full max-w-md rounded-2xl border border-amber-500/40 bg-[#131c2e] p-6 sm:p-8 shadow-2xl shadow-black/60">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-amber-500/15 border border-amber-500/40 flex items-center justify-center">
            <ShieldAlert className="w-5 h-5 text-amber-400" />
          </div>
          <h2 className="font-heading text-xl font-bold text-slate-100">
            Are you 18 or older?
          </h2>
        </div>
        <div className="space-y-3 text-sm text-slate-300 leading-relaxed">
          <p>
            Hit Path is a lottery-workout tool for people of legal gambling age in their
            jurisdiction (18+ in most US states, 21+ in Nebraska, Louisiana, Arizona, Mississippi,
            and Iowa).
          </p>
          <p className="text-slate-400">
            This app shows patterns from a personal number workout. It does{" "}
            <span className="text-amber-300">not predict</span> lottery outcomes. Lottery draws are
            random. For entertainment only. Please play responsibly.
          </p>
          <p className="text-xs text-slate-500">
            If gambling is a problem, call{" "}
            <span className="text-amber-400 font-mono-digit">1-800-GAMBLER</span>.
          </p>
        </div>
        <div className="mt-6 grid grid-cols-2 gap-3">
          <Button
            variant="outline"
            data-testid="age-gate-decline"
            onClick={decline}
            className="border-slate-700 bg-transparent hover:bg-slate-800 text-slate-200"
          >
            I&apos;m under 18
          </Button>
          <Button
            data-testid="age-gate-accept"
            onClick={accept}
            className="bg-amber-500 hover:bg-amber-400 text-slate-950 font-heading font-bold"
          >
            Yes, continue
          </Button>
        </div>
      </div>
    </div>
  );
};
